/* global femcare */

femcare.product.productFilter = {
    init: function () {

        this.$filter = $('.product-filter');

        if (this.$filter.length) {
            this.initMembers();
            this.removeUnmatchedOptions();
            this.$chips.on('click', $.proxy(this.onChipClick, this));
        }
    },

    initMembers: function () {
        this.activeChipClass = 'active';
        this.activeChipSelector = '.product-filter__chip.active';
        this.orientation = $('body').hasClass('rtl') ? 'right' : 'left';
        this.clearChipMarginShift = 'margin-' + this.orientation;

        this.$clearOption = this.$filter.find('.product-filter__option--clear');
        this.$optionAfterClear = this.$clearOption.next();

        this.$chips = this.$filter.find('.product-filter__chip');
        this.$clearChip = this.$clearOption.find('.product-filter__chip--clear');
        this.$productList = $('.product-list');
    },

    /**
     * Remove filter options which no items satisfy.
     */
    removeUnmatchedOptions: function () {
        var $products = this.$productList.find('.product-list__item');

        $.each(
            this.$chips.not(this.$clearChip),
            $.proxy(function (index, chip) {
                var $chip = $(chip);
                var resultItemAttribute =
                    'data-' + $chip.data('category') + '-' + $chip.data('option');

                var matchFound = false;
                for (
                    var productIndex = 0;
                    productIndex < $products.length;
                    productIndex++
                ) {
                    if ($products[productIndex].hasAttribute(resultItemAttribute)) {
                        matchFound = true;
                        break;
                    }
                }

                if (!matchFound) {
                    $chip.parent('.product-filter__option').remove();
                }
            }, this)
        );
    },

    onChipClick: function (event) {
        event.preventDefault();
        var $chip = $(event.currentTarget);
        var $activeChips = this.$chips.filter(this.activeChipSelector);

        // If the last active option is about to get deactivated fallback to all.
        var noChipsActive = $activeChips.length === 1 && $chip.is($($activeChips[0]));

        if ($chip.is(this.$clearChip) || noChipsActive) {
            this.clearCriteria();
        } else {
            $chip.toggleClass(this.activeChipClass);
            this.applyCriteria();
        }
    },

    applyCriteria: function () {
        var marginShiftOptions = {};
        var clearOptionWidth = this.$clearOption.outerWidth();
        marginShiftOptions[this.clearChipMarginShift] = clearOptionWidth + 10;

        this.$optionAfterClear.animate(
            marginShiftOptions,
            300,
            $.proxy(function () {
                this.$clearOption.css('visibility', 'visible');
                this.$clearChip.animate({ opacity: 1 }, 300);
            }, this)
        );

        var usageCriteria = [];
        var flowCriteria = [];
        var featureCriteria = [];

        this.$chips.filter(this.activeChipSelector).each(function (index, chip) {
            var category = $(chip).data('category');
            var option = $(chip).data('option');

            if (category === 'feature') {
                featureCriteria.push({ category: category, option: option });
            } else if (category === 'flow') {
                flowCriteria.push({ category: category, option: option });
            } else if (category === 'usage') {
                usageCriteria.push({ category: category, option: option });
            }
        });

        var allCategoryCriteria = [];
        if (usageCriteria.length) allCategoryCriteria.push(usageCriteria);
        if (flowCriteria.length) allCategoryCriteria.push(flowCriteria);
        if (featureCriteria.length) allCategoryCriteria.push(featureCriteria);
        var allRules = [];

        this.formulateRules(allCategoryCriteria, 0, allRules, []);

        this.invokeFilter(allRules);
    },

    clearCriteria: function () {
        var marginShiftOptions = {};
        this.$chips.removeClass(this.activeChipClass);

        marginShiftOptions[this.clearChipMarginShift] = 0;
        this.$clearChip.animate(
            { opacity: 0 },
            300,
            $.proxy(function () {
                this.$clearOption.css('visibility', 'hidden');
                this.$optionAfterClear.animate(marginShiftOptions, 300);
            }, this)
        );

        this.invokeFilter(null);
    },

    formulateRules: function(allCategoryCriteria, categoryIndex, allRules, rule) {
        // If the criteria selected is x1, x2, y1 and they belong to x and y categories respectively
        // then the matching items must satisfy ( x1 AND y1 ) OR ( x2 AND y1 ).
        // This is can be represented as a cartesian product where the categories are the sets.

        for (var optionIndex = 0; optionIndex < allCategoryCriteria[categoryIndex].length; optionIndex++) {
            var selectedOption = allCategoryCriteria[categoryIndex][optionIndex];
            if (categoryIndex + 1 < allCategoryCriteria.length) {
                this.formulateRules(allCategoryCriteria, categoryIndex + 1, allRules, rule.concat([selectedOption]));
            } else {
                allRules.push(rule.concat([selectedOption]));
            }
        }
    },

    invokeFilter: function (rules) {
        this.$filter.trigger('filter', { rules: rules });
    }
};








